



































































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwScrollView } from '../sw-scroll-view';
import { utilService } from '../util-service';

const cssPrefix = 'sw-app';

@Component({
  components: {
    SwScrollView,
  },
})
export default class SwApp extends SwExtendedVue {
  @Prop({ type: String, default: 'light' })
  theme: 'light' | 'dark';

  @Prop({ type: String, default: 'page' })
  mode: 'page' | 'app';

  @Prop({ type: Boolean, default: false })
  mainFitPage: boolean;

  cssPrefix = cssPrefix;

  get isMainFitMode() {
    return this.mainFitPage || this.isAppMode;
  }

  get isAppMode() {
    return this.mode === 'app';
  }

  private hasTop() {
    const slot = utilService.getVueScopedSlot(this.$scopedSlots, 'top');
    return slot.length > 0;
  }

  private hasBottom() {
    const slot = utilService.getVueScopedSlot(this.$scopedSlots, 'bottom');
    return slot.length > 0;
  }

  private hasLeft() {
    const slot = utilService.getVueScopedSlot(this.$scopedSlots, 'left');
    return slot.length > 0;
  }

  private hasRight() {
    const slot = utilService.getVueScopedSlot(this.$scopedSlots, 'right');
    return slot.length > 0;
  }

}
